var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "pc_content" } },
    [
      _c("real-intention-preview-content", {
        attrs: { "real-intention": _vm.realIntention },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "space-18px" }, [_vm._v("\n   \n  ")]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }